var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogo = function SvgLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3050,
    height: 830,
    viewBox: "0 0 3050 830",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "svg_4",
    fill: "currentColor",
    points: "1123.6680297851562,288.9346618652344 1123.6680297851562,288.9346618652344 1018.9680786132812,288.9346618652344 1018.9680786132812,538.1346740722656 1072.9680786132812,538.1346740722656 1072.9680786132812,342.9346618652344 1088.4680786132812,342.9346618652344 1174.7680053710938,538.1346740722656 1233.7680053710938,538.1346740722656 1123.6680297851562,288.9346618652344 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_5",
    fill: "currentColor",
    points: "2066.1680297851562,538.1346740722656 2066.1680297851562,538.1346740722656 2120.1680297851562,538.1346740722656 2120.1680297851562,288.9346618652344 2066.1680297851562,288.9346618652344 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_6",
    fill: "currentColor",
    points: "1343.8679809570312,288.9346618652344 1343.8679809570312,288.9346618652344 1343.8679809570312,288.9346618652344 1233.7680053710938,538.1346740722656 1292.8679809570312,538.1346740722656 1379.0680541992188,342.9346618652344 1394.5680541992188,342.9346618652344 1394.5680541992188,538.1346740722656 1448.5680541992188,538.1346740722656 1448.5680541992188,288.9346618652344 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    fill: "currentColor",
    d: "m1690.06803,288.93469l-98.8,0l0,0l-110.1,249.2l59,0l35.9,-81.2l129.2,0l35.9,81.2l59,0l-110.1,-249.2l0,0zm-90.1,114l26.5,-60l28.4,0l26.5,60l-81.4,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_8",
    fill: "currentColor",
    points: "1956.0679321289062,288.9346618652344 1831.3679809570312,288.9346618652344 1831.3679809570312,538.1346740722656 1885.3679809570312,538.1346740722656 1885.3679809570312,342.9346618652344 1920.8679809570312,342.9346618652344 2007.1680297851562,538.1346740722656 2066.1680297851562,538.1346740722656 1956.0679321289062,288.9346618652344 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_9",
    fill: "currentColor",
    points: "2150.1680297851562,288.9346618652344 2150.1680297851562,342.9346618652344 2276.1680297851562,342.9346618652344 2276.1680297851562,538.1346740722656 2330.1680297851562,538.1346740722656 2330.1680297851562,342.9346618652344 2456.1680297851562,342.9346618652344 2456.1680297851562,288.9346618652344 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_10",
    fill: "currentColor",
    points: "2540.1680297851562,288.9346618652344 2486.1680297851562,288.9346618652344 2486.1680297851562,538.1346740722656 2721.1680297851562,538.1346740722656 2721.1680297851562,484.1346740722656 2540.1680297851562,484.1346740722656 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_11",
    fill: "currentColor",
    points: "3006.1680297851562,342.9346618652344 3006.1680297851562,288.9346618652344 2751.1680297851562,288.9346618652344 2751.1680297851562,538.1346740722656 3006.1680297851562,538.1346740722656 3006.1680297851562,484.1346740722656 2805.1680297851562,484.1346740722656 2805.1680297851562,436.9346618652344 2979.4680786132812,436.9346618652344 2979.4680786132812,382.9346618652344 2805.1680297851562,382.9346618652344 2805.1680297851562,342.9346618652344 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    fill: "currentColor",
    d: "m183.96803,295.53469l-119.8,-61c-9.4,18.4 -17.3,37.7 -23.7,57.4l127.9,41.4c4.2,-13 9.4,-25.7 15.6,-37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    fill: "currentColor",
    d: "m285.66803,188.03469l66.4,114.3c9.7,-5.6 20.1,-9.9 30.8,-12.8l-34.3,-127.6c8.7,-2.3 17.6,-4.3 26.6,-5.7l-21.1,-132.8c-20.4,3.2 -40.7,8.1 -60.3,14.5l41,125.8c-13.1,4.3 -25.8,9.6 -38,15.8l-60.3,-117.7c-18.3,9.4 -36.1,20.3 -52.7,32.5l79.3,108.6c7.2,-5.4 14.8,-10.3 22.6,-14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "currentColor",
    d: "m641.76803,282.73469l-114.3,66.4c5.6,9.7 10,20.1 12.9,30.8l127.6,-34.4c2.4,8.7 4.3,17.6 5.7,26.5l132.8,-21.1c-3.2,-20.4 -8.1,-40.7 -14.6,-60.3l-125.7,41.1c-4.3,-13.1 -9.6,-25.8 -15.8,-38l117.7,-60.4c-9.4,-18.3 -20.3,-36.1 -32.5,-52.7l-108.5,79.3c5.2,7.4 10.1,15 14.7,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    fill: "currentColor",
    d: "m595.16803,61.23469c-18.4,-9.4 -37.7,-17.3 -57.4,-23.7l-41.3,127.9c12.9,4.2 25.6,9.4 37.8,15.6l60.9,-119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    fill: "currentColor",
    d: "m547.36803,185.73469l-67.1,116.5c9.7,5.6 18.7,12.5 26.6,20.4l188.2,-188.9c-14.6,-14.6 -30.5,-28.1 -47.1,-40.2l-77.6,107.1c-7.4,-5.4 -15,-10.4 -23,-14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    fill: "currentColor",
    d: "m188.56803,282.33469l116.4,67.2c5.6,-9.7 12.5,-18.7 20.4,-26.7l-188.7,-188.3c-14.6,14.6 -28.1,30.5 -40.2,47.1l107,77.7c-5.3,7.4 -10.3,15.1 -14.9,23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    fill: "currentColor",
    d: "m457.06803,153.93469l20.3,-130.7c-20.1,-3.1 -40.6,-4.7 -61.1,-4.7l-0.3,0l0,266.6l0.3,0c11.2,0 22.4,1.4 33.1,4.3l34.5,-129.9c-8.8,-2.4 -17.7,-4.2 -26.8,-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "currentColor",
    d: "m292.26803,380.43469l-129.9,-34.6c-2.3,8.8 -4.2,17.8 -5.6,26.8l-130.7,-20.4c-3.1,20.1 -4.7,40.8 -4.7,61.3l266.6,0c0,-11.3 1.5,-22.4 4.3,-33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    fill: "currentColor",
    d: "m648.76803,531.53469l119.8,61c9.4,-18.4 17.3,-37.7 23.7,-57.4l-127.9,-41.4c-4.2,13 -9.4,25.7 -15.6,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "currentColor",
    d: "m546.96803,638.93469l-66.3,-114.3c-9.7,5.6 -20.1,9.9 -30.8,12.8l34.3,127.6c-8.7,2.3 -17.6,4.3 -26.6,5.7l21.1,132.8c20.4,-3.2 40.7,-8.1 60.3,-14.5l-41,-125.8c13.1,-4.3 25.8,-9.6 38,-15.8l60.3,117.7c18.3,-9.4 36.1,-20.3 52.7,-32.5l-79.2,-108.6c-7.3,5.5 -14.9,10.4 -22.8,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    fill: "currentColor",
    d: "m190.96803,544.33469l114.3,-66.4c-5.6,-9.7 -10,-20.1 -12.9,-30.8l-127.6,34.4c-2.4,-8.7 -4.3,-17.6 -5.7,-26.5l-132.8,21.1c3.2,20.4 8.1,40.7 14.6,60.3l125.7,-41.1c4.3,13 9.6,25.8 15.8,38l-117.7,60.4c9.4,18.3 20.3,36.1 32.5,52.7l108.5,-79.3c-5.2,-7.4 -10.1,-15 -14.7,-22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    fill: "currentColor",
    d: "m237.56803,765.83469c18.4,9.4 37.7,17.3 57.4,23.7l41.3,-127.9c-12.9,-4.2 -25.6,-9.4 -37.8,-15.6l-60.9,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    fill: "currentColor",
    d: "m285.26803,641.33469l67.1,-116.5c-9.7,-5.6 -18.7,-12.5 -26.6,-20.4l-188.2,188.9c14.6,14.6 30.5,28.1 47.1,40.2l77.6,-107.1c7.4,5.3 15.1,10.3 23,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    fill: "currentColor",
    d: "m644.06803,544.73469l-116.4,-67.2c-5.6,9.7 -12.5,18.7 -20.4,26.7l188.8,188.3c14.6,-14.6 28.1,-30.5 40.2,-47.1l-107,-77.7c5.3,-7.5 10.3,-15.1 14.8,-23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    fill: "currentColor",
    d: "m383.26803,537.63469l-34.5,129.9c8.8,2.3 17.8,4.2 26.8,5.6l-20.3,130.7c20.1,3.1 40.6,4.7 61.1,4.7l0.3,0l0,-266.6l-0.3,0c-11.2,0 -22.4,-1.5 -33.1,-4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    fill: "currentColor",
    d: "m544.76803,413.53469c0,11.3 -1.4,22.4 -4.3,33.1l129.9,34.6c2.3,-8.8 4.2,-17.8 5.6,-26.8l130.7,20.4c3.1,-20.1 4.7,-40.8 4.7,-61.3l-266.6,0z"
  }))))));
};
export default SvgLogo;